import {OPEN_PRODUCT} from "../app/util/events";
import dispatchEvent from "../app/util/dispatchEvent";

export default () => {

    const tiles = document.querySelectorAll('[data-product]');
    for (const tile of tiles) {

        tile.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = tile.getAttribute('data-product');
            dispatchEvent(OPEN_PRODUCT, {
                id: productId
            });
            return false;
        });


    }


}
